/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nb-theme-default   [_nghost-%COMP%]   nb-layout-column[_ngcontent-%COMP%]{background-image:url(https://cink.cloud/public/layouts/cink/images/sign-in/bg.jpg);background-size:cover;background-position:top center;background-attachment:fixed;text-align:center;padding-top:80px!important;padding-bottom:80px!important}"];
export { styles as styles };
